import { Routes } from "@angular/router";
import { AuthGuard } from "src/app/core/guards/auth.guard";

export const PosEntryModeRoutes: Routes = [
  {
    path: "pos-entry-mode",
    loadComponent: () =>
      import("./pos-entry-mode/pos-entry-mode.component").then(
        (m) => m.PosEntryModeComponent,
      ),
    canActivate: [AuthGuard],
    children: [
      {
        path: "",
        loadComponent: () =>
          import("./pos-entry-mode-list/pos-entry-mode-list.component").then(
            (m) => m.PosEntryModeListComponent,
          ),
      },
      {
        path: "add",
        loadComponent: () =>
          import("./pos-entry-mode-form/pos-entry-mode-form.component").then(
            (m) => m.PosEntryModeFormComponent,
          ),
      },
      {
        path: "view/:id",
        loadComponent: () =>
          import("./pos-entry-mode-form/pos-entry-mode-form.component").then(
            (m) => m.PosEntryModeFormComponent,
          ),
      },
    ],
  },
];
